"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notification = void 0;
var qs = require("qs");
exports.notification = function (axios) {
    return {
        getNotifications: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/notifications?" + query);
        },
        getNotificationsSummary: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/notifications/summary?" + query);
        }
    };
};
